export default __webpack_public_path__ + "static/media/dap-white.08621665.webp";